<template>
  <div @mousedown="onWrapClick">
    <a-select
      :open="open"
      @blur="onBlur"
      style="width: 100%"
      show-search
      v-bind="$attrs"
      :filterOption="filterOption"
      @change="onChange"
    >
      <template #dropdownRender="{ menuNode }">
        <v-nodes :vnodes="menuNode" />
        <a-divider style="margin: 4px 0" />
        <div class="add_ipt">
          <a-input v-model:value="newStr" ref="iptRef" @blur="onInputBlur" @click="onInputClick"> </a-input>
          <a-button type="primary" @click="onAdd">新增</a-button>
        </div>
      </template>
    </a-select>
  </div>
</template>

<script>
import { ref, defineComponent } from 'vue'
export default defineComponent({
  components: {
    VNodes: (_, { attrs }) => {
      return attrs.vnodes
    },
  },
  setup(props, { emit }) {
    const newStr = ref('')
    const iptRef = ref(null)
    const open = ref(false)
    const hasClick = ref(false)
    const filterOption = (inputValue, option) => {
      return option.label.indexOf(inputValue) >= 0
    }

    const onBlur = () => {
      setTimeout(() => {
        if (!hasClick.value) {
          open.value = false
        }
      }, 200)
      // open.value = false
    }

    const onInputClick = () => {
      hasClick.value = true
    }

    const onInputBlur = () => {
      hasClick.value = false
      onBlur()
    }

    const onAdd = () => {
      hasClick.value = true
      emit('onAdd', newStr.value)
      setTimeout(() => {
        newStr.value = ''
      }, 0)
    }

    const onChange = (val) => {
      open.value = false
      hasClick.value = false
      emit('onChange', val)
    }

    const onWrapClick = () => {
      open.value = true
    }

    return {
      filterOption,
      onWrapClick,
      onBlur,
      onAdd,
      onInputClick,
      onInputBlur,
      onChange,
      newStr,
      iptRef,
      open,
    }
  },
})
</script>

<style lang="scss" scoped>
.add_ipt {
  display: flex;
  align-items: center;
  padding: 0 5px;
  box-sizing: border-box;
}
</style>
